<template>
  <div class="mgt-10px VueTables" v-if="factures.length">
    <div class="table-responsive">
      <table class="VueTables__table table is-striped-reverse
                    is-bordered is-fullwidth">
        <thead>
        <th>
          <div >{{ $t('detail.acomptesAffectes.title') }}</div>
        </th>
        </thead>
        <tbody>
        <tr v-for="(facture, index) in factures"
            :key="index">
          <td>
            <router-link-blank
              :to="{ name: 'c.bodac.factures', params: {id: facture.id}}"
              :message="$t('detail.acomptesAffectes.factureAcompte', {
                code: facture.code,
              })"
            />
            {{ $t('detail.acomptesAffectes.dateMontant', {
              date: facture.date,
              montant: facture.montant,
            }) }} <small v-show='etat(facture.etat)'>({{ etat(facture.etat) }})</small>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';

export default {
  props: {
    facturesAcompte: Array,
    payeurSelected: Object,
  },
  computed: {
    etat() {
      return etat => {
        const { libelle } = FACTURE_ETAT.find(e => e.code === etat);
        return libelle ? this.$t(libelle) : null;
      };
    },
    factures() {
      return this.payeurSelected
        ? this.facturesAcompte.filter(f => {
          return f.tiersId === this.payeurSelected.tiersId;
        }) : this.facturesAcompte;
    },
  },
  components: {
    routerLinkBlank,
  },
};
</script>
